const SHARE_BASE = process.env.REACT_APP_SHARE_BASE || "";

function trimTrailingSlash(value: string) {
  return String(value || "").replace(/\/+$/, "");
}

function currentOrigin() {
  if (typeof window === "undefined") return "https://todosnopadel.com.br";
  return window.location.origin;
}

function buildShareBase() {
  const configured = trimTrailingSlash(SHARE_BASE);
  return configured || currentOrigin();
}

export function getShareUrlPath(shareUrl: string) {
  try {
    const parsed = new URL(shareUrl, currentOrigin());
    return `${parsed.pathname}${parsed.search}`;
  } catch {
    return "";
  }
}

export function syncCanonicalShareUrl(shareUrl: string) {
  if (typeof window === "undefined") return;
  const nextPath = getShareUrlPath(shareUrl);
  if (!nextPath) return;
}

export function buildOpenMatchShareUrl(matchId: number | string) {
  return `${buildShareBase()}/s/partidas/${encodeURIComponent(String(matchId))}`;
}

export function buildPlayerProfileShareUrl(playerId: number | string) {
  return `${buildShareBase()}/s/jogadores/${encodeURIComponent(String(playerId))}`;
}

export function buildRankingShareUrl(params: URLSearchParams) {
  const query = params.toString();
  return `${buildShareBase()}/s/ranking${query ? `?${query}` : ""}`;
}

export function buildCompetitionShareUrl(
  competitionId: number | string,
  type: "challenge" | "tournament",
) {
  const routeBase = type === "tournament" ? "torneios" : "desafios";
  return `${buildShareBase()}/s/${routeBase}/${encodeURIComponent(String(competitionId))}`;
}
